import type { Template } from "@/types";

export const LA_05_H1_V4: Template[] = [
{
    id: "la-05-h1v4-01",
    name: "LA 01 - H1V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 41, y: 53, width: 555, height: 369, rotation: 0, imageRotation: 0 },
            { id: "2", x: 797, y: 33, width: 155, height: 202, rotation: 0, imageRotation: 0 },
            { id: "3", x: 797, y: 242, width: 155, height: 201, rotation: 0, imageRotation: 0 },
            { id: "4", x: 959, y: 33, width: 155, height: 202, rotation: 0, imageRotation: 0 },
            { id: "5", x: 959, y: 242, width: 155, height: 201, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h1v4-02",
    name: "LA 02 - H1V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 76, y: 75, width: 484, height: 325, rotation: 0, imageRotation: 0 },
            { id: "2", x: 764, y: 51, width: 276, height: 374, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1047, y: 51, width: 102, height: 120, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1047, y: 178, width: 102, height: 119, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1047, y: 306, width: 102, height: 119, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h1v4-03",
    name: "LA 03 - H1V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 121, y: 28, width: 396, height: 235, rotation: 0, imageRotation: 0 },
            { id: "2", x: 121, y: 269, width: 127, height: 178, rotation: 0, imageRotation: 0 },
            { id: "3", x: 255, y: 269, width: 127, height: 178, rotation: 0, imageRotation: 0 },
            { id: "4", x: 390, y: 269, width: 126, height: 178, rotation: 0, imageRotation: 0 },
            { id: "5", x: 799, y: 28, width: 314, height: 420, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h1v4-04",
    name: "LA 04 - H1V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 89, y: 50, width: 262, height: 376, rotation: 0, imageRotation: 0 },
            { id: "2", x: 358, y: 50, width: 189, height: 114, rotation: 0, imageRotation: 0 },
            { id: "3", x: 358, y: 170, width: 189, height: 255, rotation: 0, imageRotation: 0 },
            { id: "4", x: 725, y: 71, width: 227, height: 336, rotation: 0, imageRotation: 0 },
            { id: "5", x: 959, y: 71, width: 227, height: 336, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h1v4-05",
    name: "LA 05 - H1V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 98, y: 78, width: 217, height: 319, rotation: 0, imageRotation: 0 },
            { id: "2", x: 322, y: 78, width: 217, height: 319, rotation: 0, imageRotation: 0 },
            { id: "3", x: 727, y: 50, width: 262, height: 376, rotation: 0, imageRotation: 0 },
            { id: "4", x: 996, y: 50, width: 189, height: 114, rotation: 0, imageRotation: 0 },
            { id: "5", x: 996, y: 170, width: 189, height: 255, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h1v4-06",
    name: "LA 06 - H1V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 179, y: 50, width: 280, height: 376, rotation: 0, imageRotation: 0 },
            { id: "2", x: 777, y: 227, width: 356, height: 199, rotation: 0, imageRotation: 0 },
            { id: "3", x: 777, y: 50, width: 114, height: 169, rotation: 0, imageRotation: 0 },
            { id: "4", x: 899, y: 50, width: 114, height: 169, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1021, y: 50, width: 114, height: 169, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h1v4-07",
    name: "LA 07 - H1V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 55, width: 590, height: 368, rotation: 0, imageRotation: 0 },
            { id: "2", x: 597, y: 55, width: 266, height: 368, rotation: 0, imageRotation: 0 },
            { id: "3", x: 871, y: 55, width: 128, height: 180, rotation: 0, imageRotation: 0 },
            { id: "4", x: 871, y: 241, width: 128, height: 181, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1006, y: 55, width: 268, height: 368, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h1v4-08",
    name: "LA 08 - H1V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 55, width: 590, height: 368, rotation: 0, imageRotation: 0 },
            { id: "2", x: 597, y: 55, width: 266, height: 368, rotation: 0, imageRotation: 0 },
            { id: "3", x: 871, y: 55, width: 268, height: 368, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1146, y: 55, width: 128, height: 180, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1146, y: 241, width: 128, height: 180, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h1v4-09",
    name: "LA 09 - H1V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 30, width: 637, height: 413, rotation: 0, imageRotation: 0 },
            { id: "2", x: 793, y: 30, width: 159, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 793, y: 241, width: 159, height: 203, rotation: 0, imageRotation: 0 },
            { id: "4", x: 960, y: 30, width: 158, height: 203, rotation: 0, imageRotation: 0 },
            { id: "5", x: 960, y: 241, width: 158, height: 203, rotation: 0, imageRotation: 0 }
    ],
}
];